/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeManufacturerModelResponseDto
 */
export interface AssetTypeManufacturerModelResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    assetTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    assetTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    manufacturerId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    manufacturerName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    assetModelId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    assetModelName: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeManufacturerModelResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the AssetTypeManufacturerModelResponseDto interface.
 */
export function instanceOfAssetTypeManufacturerModelResponseDto(value: object): value is AssetTypeManufacturerModelResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('assetTypeName' in value) || value['assetTypeName'] === undefined) return false;
    if (!('manufacturerId' in value) || value['manufacturerId'] === undefined) return false;
    if (!('manufacturerName' in value) || value['manufacturerName'] === undefined) return false;
    if (!('assetModelId' in value) || value['assetModelId'] === undefined) return false;
    if (!('assetModelName' in value) || value['assetModelName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetTypeManufacturerModelResponseDtoFromJSON(json: any): AssetTypeManufacturerModelResponseDto {
    return AssetTypeManufacturerModelResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeManufacturerModelResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeManufacturerModelResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetTypeId': json['assetTypeId'],
        'assetTypeName': json['assetTypeName'],
        'manufacturerId': json['manufacturerId'],
        'manufacturerName': json['manufacturerName'],
        'assetModelId': json['assetModelId'],
        'assetModelName': json['assetModelName'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AssetTypeManufacturerModelResponseDtoToJSON(json: any): AssetTypeManufacturerModelResponseDto {
    return AssetTypeManufacturerModelResponseDtoToJSONTyped(json, false);
}

export function AssetTypeManufacturerModelResponseDtoToJSONTyped(value?: AssetTypeManufacturerModelResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetTypeId': value['assetTypeId'],
        'assetTypeName': value['assetTypeName'],
        'manufacturerId': value['manufacturerId'],
        'manufacturerName': value['manufacturerName'],
        'assetModelId': value['assetModelId'],
        'assetModelName': value['assetModelName'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

